import * as React from "react";
import Search from "../../base/Search";
import { useEffect } from "react";
import SimpleProductGroup from "../SimpleProducts/SimpleProductsGroup";
import "../style.css"
import { Stack, Label } from "@fluentui/react";

interface Props {
    query: { term?: string, debitorNo?: string };
    productGroups: ProductGroup[];
    updateSearchList: (
        query: {term: string, debitorNo: string },
        merge: boolean
    ) => void;
    take?: number;
    updateSearchProductQuery: (term?: string) => void;
    selectedProducts: (products: Product[]) => void;
    hideSearchBar?: boolean | undefined;
    debitorNo?: string;
}

const FindProduct = (props: Props) => {
    const [productGroups, setProductGroups] = React.useState<ProductGroup[]>(
        props.productGroups
    );

    useEffect(() => {
        setProductGroups(props.productGroups);
    }, [props.productGroups]);

    useEffect(() => {
        const { query: productSearchQuery } = props;
        if (
            productSearchQuery &&
            productSearchQuery.term
        ) {
            props.updateSearchList(
                {
                    term: productSearchQuery.term,
                    debitorNo: props.debitorNo ? props.debitorNo : ""
                },
                false
            );
        }
    }, []);

    const searchProduct = ( term: string, debitorNo: string) => {
        props.updateSearchList({ term, debitorNo }, true);
        props.updateSearchProductQuery(term);
    };

    let result: JSX.Element = <></>;
    if (!productGroups) {
        result = <p></p>;
    } else {
        result = (
            <SimpleProductGroup
                items={productGroups}
                selectedProducts={props.selectedProducts}
                take={props.take}
            />
        );
    }

    return (
        <Stack
            className="find-product__search"
            horizontal={true}
            tokens={{ childrenGap: 15 }}
        >
            <Stack.Item grow={2}>
                <div hidden={props.hideSearchBar === undefined ? false : true}>
                    <Label>Varer</Label>
                    <Search query={props.query} onSearch={searchProduct} debitorNo={props.debitorNo} />
                </div>
                {result}
            </Stack.Item>
        </Stack>
    );
};
export default FindProduct;
